import I18N from '@leverege/i18n';
import LazyOperatingHoursView from "./LazyOperatingHoursView.js";
const id = 'molten.dataViewers.operatingHours.OperatingHoursDataViewer';
const {
  tf,
  tfIcon
} = I18N.ns(id);
function create(objectType) {
  return {
    id: `molten.dataViewers.operatingHours.${objectType}.OperatingHoursDataViewer`,
    type: 'molten.OperatingHours',
    name: tf('name'),
    icon: tfIcon('icon', 'fa fa-fw fa-clock-o'),
    location: ['main', 'card'],
    matches: {
      objectType,
      type: 'ItemInfoDataViewer'
    },
    component: LazyOperatingHoursView
  };
}
function processBlueprints(molten, blueprints) {
  blueprints.forEach(blueprint => {
    if (blueprint.metadata?.operatingHours?.paths?.length > 0) {
      molten.addPlugin('DataViewer', create(blueprint.type));
    }
  });
}
export default {
  id: 'molten.imagine.OperatingHoursDataViewerBlueprintsProcessor',
  processBlueprints
};